import type { FC } from 'react'
import { SvgIcon, SvgIconProps } from '@mui/material'

export const TruckEaster: FC<SvgIconProps> = ({ viewBox = '0 0 254 180', ...props }) => (
  <SvgIcon viewBox={viewBox} fill="none" {...props} xmlns="http://www.w3.org/2000/svg">
    <path
      opacity=".3"
      d="m80.332 132.598 40.353-7.633-32.614-16.586-41.459 8.073 33.72 16.146Z"
      fill="url(#paint0_linear_6712_41131)"
    />
    <path
      opacity=".3"
      d="m100.785 128.487 82.089-15.705-33.167-16.44-81.95 16.147 33.028 15.998Z"
      fill="url(#paint1_linear_6712_41131)"
    />
    <path
      d="M183.971 108.457c3.83-3.599 4.475-9.47 1.441-13.113-3.035-3.643-8.599-3.679-12.43-.08-3.83 3.599-4.475 9.47-1.441 13.113 3.035 3.643 8.6 3.678 12.43.08ZM115.572 124.231l-4.146-2.055v-4.99h2.764l1.382 7.045Z"
      fill="#000"
    />
    <path
      d="m171.265 80.197 19.486-1.762-19.21-10.127c-2.487-1.175-5.113-1.762-7.877-1.615l-17.136.294 24.737 13.21Z"
      fill="#FDDE84"
    />
    <path d="m125.5 50-27 61.5-11.673 1.428-10.78-5.724V59.501L125.5 50Z" fill="#C1A656" />
    <path
      d="m146.666 69.041 17.413-2.935-21.144-11.155c-2.903-1.468-6.219-2.055-9.398-1.468L121.1 55.685l25.566 13.356Z"
      fill="#FDDE84"
    />
    <path
      d="M195.311 100.306v-16.88c0-2.788-4.284-6.018-7.739-6.018l-7.739.147-12.576-10.128c-3.455-2.789-8.015-3.963-12.299-3.229l-8.43 1.615v43.153l26.119-4.844 22.664-3.816Z"
      fill="#FCCE09"
    />
    <path d="M147.357 65.812v43.007l-21.697-6.606v-47.85l21.697 11.45Z" fill="#C39000" />
    <path d="m97.606 70.95 48.645-9.541-21.42-11.449-48.783 9.54 21.558 11.45Z" fill="#FDDE84" />
    <path d="m151.503 82.692 24.599-4.55-11.885-9.688-14.787 2.789 2.073 11.449Z" fill="#4C4C4C" />
    <path d="m162.559 80.49 13.543-2.348-11.885-9.688-7.186 1.468-5.804 1.027 11.332 9.541Z" fill="#3A3A3A" />
    <path d="m169.607 79.316 6.495-1.174-11.885-9.688-7.186 1.468 12.576 9.394Z" fill="#28211E" />
    <path
      d="M121.878 120.446c3.831-3.599 4.476-9.469 1.441-13.113-3.034-3.643-8.599-3.678-12.429-.08-3.83 3.599-4.475 9.47-1.441 13.113 3.035 3.643 8.599 3.679 12.429.08Z"
      fill="#000"
    />
    <path d="M97.606 70.95v47.703l48.645-9.54V61.409l-48.645 9.54Z" fill="#FCCE09" />
    <path
      d="M152.47 87.83v.587l3.593-.734c0-.881-.553-1.468-1.382-1.468h-.276l-.967.147c-.553.293-1.244 1.027-.968 1.467Z"
      fill="#28211E"
    />
    <path d="M97.606 110.874v9.981l97.705-18.788V91.94l-97.705 18.934Z" fill="#3A3A3A" />
    <path d="m177.484 112.048-4.146-2.202v-4.844l2.764.147 1.382 6.899Z" fill="#000" />
    <path
      d="M171.265 106.617c-.415-6.311 3.731-12.036 9.535-13.357 5.114-1.174 10.089 2.202 11.194 7.633.138.44.138 1.027.138 1.468"
      fill="#000"
    />
    <path
      d="M187.577 110.376c3.83-3.599 4.475-9.469 1.441-13.112-3.034-3.643-8.599-3.68-12.429-.08-3.83 3.598-4.475 9.469-1.441 13.112 3.034 3.643 8.599 3.679 12.429.08Z"
      fill="#28211E"
    />
    <path
      d="M185.38 107.738c2.286-2.149 2.664-5.663.844-7.848-1.821-2.186-5.151-2.216-7.437-.068-2.287 2.149-2.665 5.662-.844 7.848 1.821 2.186 5.15 2.216 7.437.068Z"
      fill="#3A3A3A"
    />
    <path
      d="M183.64 105.649c1.086-1.021 1.27-2.685.41-3.717-.86-1.032-2.437-1.042-3.523-.021-1.086 1.02-1.27 2.685-.41 3.717.859 1.032 2.437 1.041 3.523.021Z"
      fill="#4C4C4C"
    />
    <path
      d="M109.215 118.653c-.415-6.311 3.731-12.036 9.536-13.357 5.113-1.174 10.088 2.202 11.193 7.633.139.44.139 1.027.139 1.468"
      fill="#000"
    />
    <path
      d="M97.606 110.874v9.981l-21.558-11.302v-9.981l21.558 11.302ZM125.474 122.359c3.83-3.599 4.475-9.469 1.441-13.112-3.035-3.643-8.599-3.679-12.43-.081-3.83 3.599-4.475 9.47-1.441 13.113 3.035 3.643 8.599 3.679 12.43.08Z"
      fill="#28211E"
    />
    <path
      d="M123.276 119.721c2.286-2.149 2.664-5.663.844-7.848-1.821-2.186-5.151-2.216-7.437-.068-2.287 2.149-2.665 5.662-.844 7.848 1.821 2.186 5.15 2.216 7.437.068Z"
      fill="#3A3A3A"
    />
    <path
      d="M121.536 117.632c1.029-.967 1.166-2.588.307-3.62-.86-1.032-2.391-1.085-3.42-.118s-1.166 2.587-.307 3.619c.86 1.033 2.391 1.086 3.42.119Z"
      fill="#4C4C4C"
    />
    <path
      d="m101.062 78.729 3.454-.44-.138.293-3.316.44v-.293ZM101.062 78.289l3.869-.734-.276.293-3.593.734v-.293Z"
      fill="#D40511"
    />
    <path
      d="m101.062 79.316 3.178-.734-.138.44-3.04.588v-.294ZM126.628 73.885l-3.455.734.276-.293 3.179-.587v.146ZM126.628 74.326l-3.731 1.027.138-.44 3.593-.734v.147ZM123.726 73.885l2.902-.734v.294l-3.041.734.139-.294ZM104.516 79.023l1.659-2.642 2.073-.44c.276 0 .276 0 .138.293l-.415.587c0 .147-.138.294.139.147l2.763-.587c-.552.88-1.382 1.468-2.349 1.761l-4.008.88ZM113.914 75.647l-.968 1.468-2.349.44.967-1.174 2.35-.734ZM117.23 75.207l-.829 1.467-2.349.44.967-1.467 2.211-.44ZM118.06 74.913l-.277.44c-.276.44 0 .88.968.734l3.731-.734.829-1.468-5.251 1.028Z"
      fill="#D40511"
    />
    <path
      d="m105.622 74.913-.829 1.32 4.422-.88c.276 0 .276 0 .138.147l-.414.734c0 .146-.138.293.138.146l1.796-.293.553-.88c.277-.588 0-1.469-1.105-1.175l-4.699.88ZM117.507 74.913l-5.804.88 1.52-2.348 2.349-.587-.829 1.468.967-.147.968-1.468 2.349-.293-1.52 2.495ZM122.344 71.684l-1.52 2.495-2.488.44 1.52-2.495 2.488-.44Z"
      fill="#D40511"
    />
    <path d="M147.357 101.04v10.274l-1.106.294v-11.302l1.106.734Z" fill="#28211E" />
    <path
      d="M161.177 89.297v-.44l12.852-2.496v.587l-12.852 2.349ZM161.177 91.793v-.44l6.219-1.322v.44l-6.219 1.322Z"
      fill="#000"
    />
    <path d="m97 95-21 4.5 21 11V95Z" fill="#000" fillOpacity=".9" />
    <path
      opacity=".1"
      d="M90.392 102.256c0 .427-2.38.733-5.31.733-2.931 0-5.312-.367-5.312-.733s2.38-.733 5.311-.733c2.93 0 5.311.306 5.311.733ZM100.376 100.037c0 .428-2.38.733-5.31.733-2.93 0-5.312-.366-5.312-.733 0-.366 2.381-.732 5.311-.732s5.311.305 5.311.732Z"
      fill="#000"
    />
    <path
      d="M101.6 92.44c0 3.922-3.17 7.575-7.092 7.575-3.923 0-7.093-3.653-7.093-7.576 0-3.922 2.257-10.691 7.093-10.691 4.459.005 7.092 6.77 7.092 10.691Z"
      fill="url(#paint2_linear_6712_41131)"
    />
    <path
      d="M90.328 83.87a7.022 7.022 0 0 0-.387.489c1.526.26 3.072.393 4.62.397a32.87 32.87 0 0 0 4.417-.311 8.371 8.371 0 0 0-.382-.484 34.019 34.019 0 0 1-4.035.258 26.605 26.605 0 0 1-4.233-.35Z"
      fill="#FFC665"
    />
    <path
      d="M100.901 95.588a7.692 7.692 0 0 0 .699-3.148v-.274c-2.37.522-4.789.794-7.216.81a25.453 25.453 0 0 1-6.984-1.004v.468a7.656 7.656 0 0 0 .65 3.046c2.078.47 4.203.71 6.334.715a36.737 36.737 0 0 0 6.517-.613Z"
      fill="#DC5B29"
    />
    <path
      d="M90.559 98.661a6.447 6.447 0 0 0 7.914 0c-1.404.185-2.818.28-4.234.285a25.56 25.56 0 0 1-3.68-.285ZM87.937 95.185c.14.37.307.729.5 1.074 1.975.44 3.993.666 6.017.672a35.651 35.651 0 0 0 6.055-.538c.204-.332.384-.678.538-1.037a35.46 35.46 0 0 1-6.662.63 27.017 27.017 0 0 1-6.448-.801Z"
      fill="#FFC665"
    />
    <path
      d="M94.991 94.535a.483.483 0 1 1-.966 0 .483.483 0 0 1 .966 0ZM96.872 94.481a.484.484 0 1 1-.969 0 .484.484 0 0 1 .969 0ZM98.683 94.266a.484.484 0 1 1-.484-.483.57.57 0 0 1 .484.483ZM100.294 94.11a.484.484 0 1 1-.968.002.484.484 0 0 1 .968-.001ZM91.23 94.266a.483.483 0 1 1-.966 0 .483.483 0 0 1 .966 0ZM88.92 94.427a.484.484 0 1 0 0-.967.484.484 0 0 0 0 .968ZM93.057 94.481a.483.483 0 1 1-.483-.483.452.452 0 0 1 .483.483ZM90.032 84.235c-.263.342-.503.701-.72 1.075 1.73.331 3.488.5 5.25.505a34.926 34.926 0 0 0 5.06-.387 11.107 11.107 0 0 0-.72-1.101c-1.438.198-2.888.3-4.34.306a26.14 26.14 0 0 1-4.53-.398Z"
      fill="#FFF7E4"
    />
    <path
      d="M88.361 87.4c-.107.29-.204.58-.29.87 2.125.516 4.304.779 6.49.784a35.909 35.909 0 0 0 6.367-.59c-.091-.302-.193-.602-.306-.898-2.017.37-4.063.563-6.114.575a26.8 26.8 0 0 1-6.147-.742Z"
      fill="#FFC665"
    />
    <path
      d="M88.13 88.077c-.26.834-.452 1.687-.575 2.552 2.282.591 4.628.892 6.985.897 2.32-.006 4.635-.24 6.909-.698a15.86 15.86 0 0 0-.601-2.563 34.093 34.093 0 0 1-6.362.629 26.198 26.198 0 0 1-6.356-.817Z"
      fill="#FFF7E4"
    />
    <path
      d="M94.991 90.29a.483.483 0 1 1-.483-.483.537.537 0 0 1 .483.484ZM96.925 90.29a.484.484 0 1 1-.967 0 .484.484 0 0 1 .968 0ZM98.683 90.075a.484.484 0 1 1-.484-.483c.322.053.484.215.484.483ZM99.88 90.35a.48.48 0 0 0 .447-.3.486.486 0 0 0-.632-.63.484.484 0 0 0 .185.93ZM90.8 90.505a.484.484 0 1 0 0-.967.484.484 0 0 0 0 .967ZM89.403 89.753a.484.484 0 1 1-.967 0 .484.484 0 0 1 .967 0ZM93.11 90.29a.484.484 0 1 1-.967 0 .484.484 0 0 1 .968 0Z"
      fill="#FFA752"
    />
    <path
      d="M93.34 96.694c-1.214 3.968-5.573 6.673-9.502 5.418-3.93-1.254-6.022-5.887-4.812-9.86s5.596-10.123 10.466-8.598c4.54 1.426 5.108 9.114 3.849 13.04Z"
      fill="url(#paint3_linear_6712_41131)"
    />
    <path
      d="M93.34 96.694c-1.214 3.968-5.573 6.673-9.502 5.418-3.93-1.254-6.022-5.887-4.812-9.86s5.596-10.123 10.466-8.598c4.54 1.426 5.108 9.114 3.849 13.04Z"
      fill="url(#paint4_linear_6712_41131)"
    />
    <path
      d="M92.27 90.838a.553.553 0 0 1-.603.353.494.494 0 1 1 .25-.956.504.504 0 0 1 .353.603ZM90.213 96.73a.572.572 0 0 1-.607.358.56.56 0 0 1-.357-.608.553.553 0 0 1 .603-.352.498.498 0 0 1 .36.603ZM87.616 89.643a.553.553 0 0 1-.603.353.577.577 0 0 1-.353-.604.56.56 0 0 1 .604-.352.49.49 0 0 1 .352.603ZM85.807 95.521a.498.498 0 1 1-.967-.24.498.498 0 0 1 .967.24ZM81.745 94.137a.492.492 0 1 1-.182-.523.497.497 0 0 1 .182.523ZM83.632 87.984a.572.572 0 0 1-.607.357.499.499 0 1 1 .25-.965.455.455 0 0 1 .357.608Z"
      fill="#F59DA7"
    />
    <path
      d="M88.552 85.404a18.702 18.702 0 0 1-3.178-1.33 9.012 9.012 0 0 0-1.223.745 21.818 21.818 0 0 0 4.026 1.764 25.4 25.4 0 0 0 4.927.98 8.997 8.997 0 0 0-.614-1.33 22.59 22.59 0 0 1-3.938-.83ZM80.917 88.343c-.228.344-.434.691-.642 1.06a29.856 29.856 0 0 0 6.166 2.7 39.79 39.79 0 0 0 7.464 1.487c.024-.414.037-.836.033-1.264a36.272 36.272 0 0 1-7.162-1.402 27.511 27.511 0 0 1-5.86-2.582ZM91.94 99.327c.297-.37.56-.765.786-1.182a36.591 36.591 0 0 1-7.95-1.48 27.666 27.666 0 0 1-6.066-2.668c-.036.468-.032.937.014 1.403a29.507 29.507 0 0 0 5.673 2.44 41.137 41.137 0 0 0 7.543 1.487Z"
      fill="#75A5DE"
    />
    <path
      d="m93.643 89.511-1.49-1.455-2.547 1.114-1.746-2.179-2.423.898-1.202-2.287-1.334.272a11.48 11.48 0 0 0-.656.704l1.734-.37 1.156 2.337 2.486-.88 1.79 2.213 2.594-1.162 1.769 1.725a8.425 8.425 0 0 0-.131-.93ZM93.612 95.644c.048-.238.095-.483.132-.737l-1.414.886-1.981-1.934-2.547 1.114-1.746-2.179-2.38.854-1.233-2.25-2.515.551-.38-1.09a13.26 13.26 0 0 0-.321.806l.316.944 2.602-.551 1.243 2.336 2.423-.899 1.794 2.217 2.59-1.158 2.069 1.933 1.348-.843ZM88.68 99.708l-2.552 1.11-1.774-2.154-2.384.85-1.19-2.285-1.55.337c.064.176.14.347.216.518l1.045-.205 1.27 2.35 2.467-.943 1.794 2.217 2.59-1.158 1.05 1.019c.158-.09.31-.189.457-.296l-1.439-1.36Z"
      fill="#FFFAEC"
    />
    <path d="M108 75.821V116l-11-4.821V71l11 4.821ZM77 59.849V99.5l-11-4.822V54l11 5.849Z" fill="#C39000" />
    <defs>
      <linearGradient
        id="paint0_linear_6712_41131"
        x1="77.676"
        y1="133.301"
        x2="90.957"
        y2="108.764"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_6712_41131"
        x1="113.559"
        y1="137.152"
        x2="139.437"
        y2="89.311"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".27" stopColor="#1D1D1B" stopOpacity="0" />
        <stop offset=".93" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_6712_41131"
        x1="88.683"
        y1="85.444"
        x2="100.235"
        y2="96.996"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFA752" />
        <stop offset="1" stopColor="#DC5B29" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_6712_41131"
        x1="82.947"
        y1="84.243"
        x2="90.955"
        y2="99.382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset="1" stopColor="#9E78B8" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_6712_41131"
        x1="82.947"
        y1="84.243"
        x2="90.955"
        y2="99.382"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#B89BCB" />
        <stop offset="1" stopColor="#9E78B8" />
      </linearGradient>
    </defs>
  </SvgIcon>
)
